'use client';

import { Plus } from 'lucide-react';
import { InfoTooltip } from '../../shared/InfoTooltip';
import Tooltip from '../../shared/Tooltip';
import DeleteIcon from '../../../assets/icons/delete-icon.js';

export default function ListManager({
  items,
  onAdd,
  onRemove,
  onUpdate,
  label,
  addButtonText,
  required = false,
  tooltip = '',
  error = null,
  maxLength = null,
  placeholder = '',
  filterNumbers = false,
}) {
  const getTooltipPlacement = (label) => {
    return (label || '').length > 10 ? 'top' : 'right';
  };
  const handleChange = (index, value) => {
    // Filter out numbers if filterNumbers is true (for author/editor/translator names)
    if (filterNumbers) {
      value = value.replace(/[0-9]/g, '');
    }
    onUpdate(index, value);
  };

  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-2">
        <label className="text-sm font-bold text-dark-blue">
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
        <Tooltip content={tooltip} placement={getTooltipPlacement(label)}>
          <InfoTooltip />
        </Tooltip>
      </div>
      {items.map((item, index) => (
        <div key={index} className="relative mb-2">
          <input
            type="text"
            value={item}
            onChange={(e) => handleChange(index, e.target.value)}
            maxLength={maxLength}
            placeholder={placeholder}
            className={`w-full rounded-[10px] border px-4 xl:py-3 py-2 pr-10 text-dark-blue text-sm focus:ring-1 outline-none ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray focus:ring-purple'
              }`}
          />
          {items.length > 1 && (
            <button
              onClick={() => onRemove(index)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 rounded-full flex items-center justify-center transition-colors"
            >
              {/* <img src={DeleteIcon} alt="Delete" className="w-6 h-6" /> */}
              <DeleteIcon width={14} height={14} className="inline-block" />
            </button>
          )}
        </div>
      ))}
      {error && <p className="mt-1 text-xs text-red-600 mb-2">{error}</p>}
      <button
        onClick={onAdd}
        className="flex items-center gap-2 text-dark-blue text-[12px] font-medium"
      >
        <Plus className="w-4 h-4" />
        {addButtonText}
      </button>
    </div>
  );
}
